/// <reference types="@angular/localize" />

console.log("WIP-Admin V 1.0.0 A")

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import * as Sentry from "@sentry/angular-ivy";

if (environment.production) {
  enableProdMode();
}

// #region SENTRY
Sentry.init({
  dsn: "https://8daf5b8875b8270913cb4319cc351864@o4505801365192704.ingest.sentry.io/4505801380986880",
  integrations: [
    // Registers and configures the Tracing integration,
    // which automatically instruments your application to monitor its
    // performance, including custom Angular routing instrumentation
    Sentry.browserTracingIntegration(),
    // Registers the Replay integration,
    // which automatically captures Session Replays
    Sentry.replayIntegration(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.1,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  ignoreErrors: [
    "auth/wrong-password",
    "auth/user-not-found",
    "auth/too-many-requests",
    "auth/invalid-credential"
  ],
});
// #endregion


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
